import  { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Import each image directly
import project1 from "../asset/Images/ourproducts1.jpeg";
import project2 from "../asset/Images/ourproducts2.jpeg";
import project3 from "../asset/Images/ourproducts3.jpeg";
import project4 from "../asset/Images/ourproducts4.jpeg";
import project5 from "../asset/Images/ourproducts5.jpeg";

const projectImages = [project1, project2, project3, project4, project5];

const Projects = () => {
  const [current, setCurrent] = useState(0);

  const goPrev = () => {
    setCurrent((prev) => (prev === 0 ? projectImages.length - 1 : prev - 1));
  };

  const goNext = () => {
    setCurrent((prev) => (prev === projectImages.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="w-full flex flex-col items-center gap-4 sm:gap-5 mt-10">
      {/* Heading + View Projects */}
      <div className="flex items-center justify-between w-full max-w-4xl md:max-w-5xl lg:max-w-6xl xl:max-w-7xl mx-auto px-1">
        <h2 className="text-2xl sm:text-3xl font-bold text-[#0f0f0f]">
          Our Projects
        </h2>

        <Link
          to="/portfolio"
          className="
            inline-flex items-center gap-2
            border-2 border-[#c021d6]
            text-[#c021d6]
            font-semibold
            px-5 sm:px-6
            py-2.5
            rounded-full
            hover:bg-[#c021d6]
            hover:text-white
            transition-all
            text-sm sm:text-base
          "
        >
          View Projects
        </Link>
      </div>

      {/* Slider */}
      <div className="relative w-full max-w-4xl md:max-w-5xl lg:max-w-6xl xl:max-w-7xl mx-auto">
        <div className="overflow-hidden rounded-2xl sm:rounded-3xl shadow-xl border border-gray-200">
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${current * 100}%)` }}
          >
            {projectImages.map((src, index) => (
              <img
                key={index}
                src={src}
                alt={`Project ${index + 1}`}
                className="w-full flex-shrink-0 object-cover aspect-[16/9]"
              />
            ))}
          </div>
        </div>

        {/* Prev Button */}
        <button
          onClick={goPrev}
          aria-label="Previous project"
          className="
            absolute left-2 sm:left-4 top-1/2 -translate-y-1/2
            flex h-9 w-9 sm:h-11 sm:w-11 items-center justify-center
            rounded-full bg-white/90 shadow-lg
            text-gray-700 hover:bg-white hover:text-purple-700
            transition-all duration-300
          "
        >
          <ChevronLeft size={20} />
        </button>

        {/* Next Button */}
        <button
          onClick={goNext}
          aria-label="Next project"
          className="
            absolute right-2 sm:right-4 top-1/2 -translate-y-1/2
            flex h-9 w-9 sm:h-11 sm:w-11 items-center justify-center
            rounded-full bg-white/90 shadow-lg
            text-gray-700 hover:bg-white hover:text-purple-700
            transition-all duration-300
          "
        >
          <ChevronRight size={20} />
        </button>

        {/* Dots */}
        <div className="absolute bottom-3 sm:bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
          {projectImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              aria-label={`Go to slide ${index + 1}`}
              className={`
                h-2 rounded-full transition-all duration-300
                ${current === index ? "w-6 bg-white" : "w-2 bg-white/60 hover:bg-white/80"}
              `}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;